import { AuthContextProps } from 'react-oidc-context';
import BaseService from './base';
import { IVerification, IVerificationRequest } from '../types/verification';

/**
 * VerificationService class
 *
 * @export
 * @class VerificationService
 */
export default class VerificationService extends BaseService {
  constructor(auth: AuthContextProps) {
    super(auth);
  }

  /**
   * Fetch all verifications
   * @returns {Promise<IVerification[]>}
   */
  async fetchVerifications(): Promise<IVerification[]> {
    const body = await this.get<IVerification[]>('/verification/admin/list');
    return body;
  }

  async fetchVerificationRequests(): Promise<IVerificationRequest[]> {
    const body = await this.get<IVerificationRequest[]>('/verification/admin/requests');
    return body;
  }

  async fetchAllItems() {
    const body = await this.get<any>('/verification/admin/all-items');
    return body;
  }
  /**
   * Create a new proof request using present-proof v2.0 API
   * @param {string} verification_id
   * @param {string} comment
   * @param {boolean} auto_verify
   * @param {boolean} auto_remove
   * @returns {Promise<any>}
   */
  async createVerificationRequest(
    verification_id: string,
    comment: string,
    auto_verify: boolean,
    auto_remove: boolean
  ): Promise<any> {
    const body = await this.post<any>(
      `/verification/admin/${verification_id}/create-proof-request`,
      { comment, auto_verify, auto_remove }
    );
    return body;
  }

  /**
   * Send a verification request to a user
   * @param {string} verification_id
   * @param {string} email
   * @returns {Promise<any>}
   */
  async sendVerificationRequest(verification_id: string, email: string): Promise<any> {
    const body = await this.post<any>(`/verification/admin/${verification_id}/send-proof-request`, {
      email
    });
    return body;
  }

  async sendGroupVerificationRequest(
    verification_id: string,
    connectionIds: string[]
  ): Promise<any> {
    const body = await this.post<any>(
      `/verification/admin/${verification_id}/send-group-proof-request`,
      { connectionIds }
    );
    return body;
  }
}
